<div class="vide-alert-dialog">
    <div class="vide-alert-dialog__header">
        <button mat-icon-button class="vide-alert-dialog__close" (click)="fechar()" type="button" aria-label="Fechar">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="vide-alert-dialog__body">
        <div class="vide-alert-dialog__video">
            <iframe
                [src]="videoUrl"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
            ></iframe>
        </div>
    </div>
</div>
